import React from "react";
import serviceThumb from "../../assets/images/service-thumb-1.png";

function ServicesHomeEight() {
  return (
    <>
      <section
        className="appie-services-2-area appie-services-8-area pt-90 pb-55"
        id="service"
      >
        <div className="container">
          <div className="row align-items-end">
            <div className="col-lg-12 col-md-12">
              <div className="appie-section-title mb-30 text-center">
                <h3 className="appie-title">Sectors</h3>
                {/* <p>We are partnered with major companies.</p> */}
                {/* <p>
                  Universe Media, works with you throughout your engagement and
                  beyond to make sure your goals are achieved now – and as your
                  business grows and evolves.
                </p> */}
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-4 col-md-4">
                  <div
                    className="
                    appie-single-service-2 appie-single-service-about
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                    data-wow-duration="2000ms"
                    data-wow-delay="200ms"
                  >
                    <div className="icon">
                      <i className="fal fa-tv" />
                    </div>
                    <h4 className="title">Hospitality</h4>
                    <p>
                      We provide cutting-edge Audio Visual, IT, and Smart Booking solutions designed to enhance guest experiences in hotels and resorts. With AI and IoT integration, our systems deliver seamless room automation, smart entertainment, and efficient resource management, helping hospitality businesses improve service quality and operational efficiency.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div
                    className="
                    appie-single-service-2 appie-single-service-about
                    item-2
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                    data-wow-duration="2000ms"
                    data-wow-delay="400ms"
                  >
                    <div className="icon">
                      <i className="fal fa-graduation-cap " />
                    </div>
                    <h4 className="title">Education</h4>
                    <p>
                      Our smart education solutions combine Audio Visual technology, IT systems, and AI-powered tools to create interactive classrooms and efficient campus management. From smart displays to IoT-enabled automation, we help educational institutions offer modern learning experiences while optimizing resources and connectivity.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div
                    className="
                    appie-single-service-2 appie-single-service-about
                    item-3
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                    data-wow-duration="2000ms"
                    data-wow-delay="600ms"
                  >
                    <div className="icon">
                      <i className="fal fa-plus-square" />
                    </div>
                    <h4 className="title">Healthcare</h4>
                    <p>
                      In healthcare facilities, our Audio Visual, IT, and AI-driven solutions improve communication, patient engagement, and operational workflows. IoT-enabled systems support real-time monitoring, digital signage, and smart resource scheduling, helping hospitals and clinics deliver better care and efficient services.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div
                    className="
                    appie-single-service-2 appie-single-service-about
                    item-4
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                    data-wow-duration="2000ms"
                    data-wow-delay="200ms"
                  >
                    <div className="icon">
                      <i className="fal fa-trophy" />
                    </div>
                    <h4 className="title">Sports Arena</h4>
                    <p>
                      For sports arenas, we deliver immersive Audio Visual setups, IT networks, and AI-powered analytics to enhance customer engagement and fan experiences. IoT-based automation and smart booking systems streamline operations, from event scheduling to energy management, ensuring smooth and efficient facility management.
                    </p>
                  </div>
                </div>
                 <div className="col-lg-4 col-md-4">
                  <div
                    className="
                    appie-single-service-2 appie-single-service-about
                    item-4
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                    data-wow-duration="2000ms"
                    data-wow-delay="200ms"
                  >
                    <div className="icon">
                      <i className="fal fa-building" />
                    </div>
                    <h4 className="title">Housing Complexes</h4>
                    <p>
                      Our solutions for residential communities integrate Audio Visual, IT, Smart Booking, and IoT technologies to create modern, connected living spaces. Residents benefit from smart home automation, digital communication platforms, and energy-efficient systems, ensuring comfort, convenience, and security.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-5">
              <div className="service-thumb">
                <img src={serviceThumb} alt="" />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default ServicesHomeEight;
